export default __webpack_public_path__ + "7edcae8562cf9827855f5d43d4f2e685.svg";